import { CASH_AMOUNT_PAID_INPUT_PROPS, CASH_RECEIVED, useSummaryCashAmountPaid } from '@makemydeal/dr-dash-components';
import { NumericInput } from '@makemydeal/dr-shared-components/numeric-input';

import { useScenarioCellId } from '../../../hooks/useScenarioCellId';
import { ScenarioRow } from '../../ScenarioRow';

export const CashReceivedRow = () => {
    const { label, ...inputProps } = useSummaryCashAmountPaid({ label: CASH_RECEIVED });
    const inputId = useScenarioCellId('cashDown');

    return (
        <ScenarioRow rowKey="cashDown" label={label} inputId={inputId}>
            <NumericInput
                {...CASH_AMOUNT_PAID_INPUT_PROPS}
                {...inputProps}
                id={inputId}
                name="cash-amount-paid-input-summary"
                data-testid="cash-amount-paid-input-summary"
                displayLabel={false}
                size="sm"
            />
        </ScenarioRow>
    );
};
